var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2GuestsBedroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM58 39H40v-4.6a9 9 0 0118 .1V39zM42 53.09a7 7 0 008.4 6.86 7.13 7.13 0 005.6-7.08V45h2v-3H40v3h2v8.09zM46 45h6v7.87A3.15 3.15 0 0149.63 56 3 3 0 0146 53.09V45zM36 34.49V39H18v-4.6a9 9 0 0118 .1v-.01zM18 45h2v8.09a7 7 0 008.4 6.86 7.13 7.13 0 005.6-7.08V45h2v-3H18v3zm6 0h6v7.87A3.15 3.15 0 0127.63 56 3 3 0 0124 53.09V45z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Guests_bedroom.8ed14b71.svg";
export { SvgE2GuestsBedroom as ReactComponent };